import React from "react";

import { withRouter } from "react-router-dom";

import TerminalsService from "../../../services/terminals/TerminalsService";

import AdminPage from "./../common/AdminPage";
import Terminal from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/terminal/Terminal";

const TerminalPage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history}>
      <Terminal
        loadMerchants={TerminalsService.getMerchants}
        loadTerminals={TerminalsService.getTerminals}
        onCreateTerminal={TerminalsService.createTerminal}
        onUpdateTerminal={TerminalsService.updateTerminal}
        onDeleteTerminal={TerminalsService.deleteTerminal}
      />
    </AdminPage>
  );
};

export default withRouter(TerminalPage);
